import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { PagePaths } from '@constants/paths';
import { AUTH_RETURN_URL } from '@constants/queryParams';
import { PARTNER_PORTAL } from '@constants/storageKeys';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { ClientType, useAuthContext } from '@services/Auth';
import { getBaseUrl } from '@utils/routing';

export const Basket = () => {
  const { basketId } = useParams();
  const { setBasketId } = useBasketContext();
  const { activeClient, clients } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!basketId) {
      // This should never happen because the route requires a basketId parameter.
      throw new Error('Missing basketId route parameter');
    }

    setBasketId(basketId);

    const isLoggedIn = activeClient || hasStoredTokens('quote');
    if (
      !clients[ClientType.PartnerApp] &&
      !isLoggedIn &&
      hasStoredTokens(PARTNER_PORTAL)
    ) {
      const returnUrl = `${getBaseUrl()}/${PagePaths.Bundle}`;
      window.location.replace(
        `${getBaseUrl()}/auth/okta/external/login?${AUTH_RETURN_URL}=${encodeURIComponent(returnUrl)}`
      );
      return;
    }

    navigate(`/${PagePaths.Bundle}`, { replace: true });
  });

  return null;
};

const hasStoredTokens = (key: string) => {
  try {
    return (
      Object.keys(JSON.parse(localStorage.getItem(key) ?? '{}')).length > 0
    );
  } catch {
    return false;
  }
};
